import React from "react";
import { SectionTitle } from "../common";
import PhotoGallery from "./PhotoGallery";
import { useSale } from "../../hooks/useSale";
import { Photo } from "../../types";

const getYoutubeEmbedUrl = (watchUrl?: string) => {
  if (!watchUrl) {
    return null;
  }

  try {
    const parsedUrl = new URL(watchUrl);

    if (parsedUrl.hostname.includes("youtu.be")) {
      const id = parsedUrl.pathname.replace("/", "");
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }

    if (parsedUrl.hostname.includes("youtube.com")) {
      const id = parsedUrl.searchParams.get("v");
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
  } catch (error) {
    console.error("Invalid YouTube URL provided for sale video", error);
  }

  return null;
};

const AILHLaunchSection: React.FC = () => {
  const { sale } = useSale();
  const descriptionParagraphs = sale?.description
    ? sale.description
        .split("\n")
        .map((text) => text.trim())
        .filter((text) => text.length > 0)
    : [];
  const videoSrc = getYoutubeEmbedUrl(sale?.url_link || "");

  // Dynamically collect all image fields from the sale object
  const launchPhotos: Photo[] = sale
    ? Object.keys(sale)
        .filter((key) => key.startsWith("image") && sale[key])
        .sort((a, b) => {
          // Sort by image number (image1, image2, image3, etc.)
          const numA = parseInt(a.replace("image", "")) || 0;
          const numB = parseInt(b.replace("image", "")) || 0;
          return numA - numB;
        })
        .map((key, index) => ({
          src: sale[key] as string,
          alt: `AILH Launch Photo ${index + 1}`,
          title: "AILH Launch Event",
        }))
    : [];

  return (
    <section id="section-about">
      <div id="animated-bg-container" style={{ position: "relative" }}>
        <div className="container">
          <SectionTitle
            subtitle="[ AILH Launch ]"
            title="AILH Launch with Honorable Guest"
          />

          <div className="row">
            <div className="col-lg-6">
              {descriptionParagraphs.map((text, index) => (
                <p
                  key={text.substring(0, 20) + index}
                  className={index === 0 ? "lead" : undefined}
                >
                  {text}
                </p>
              ))}
            </div>
            <div className="col-lg-6">
              {videoSrc && (
                <div className="video-wrapper mb-4">
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={videoSrc}
                      title="AILH Launch Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              )}
            </div>
          </div>

          {launchPhotos.length > 0 && (
            <div className="row mt-5">
              <div className="col-12">
                <PhotoGallery photos={launchPhotos} />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AILHLaunchSection;
